(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-article-share"] && !Shopify.designMode) return;
  try {
    
  // „Kopírovat odkaz" — bez závislostí, s tichým fallbackem.
  document.querySelectorAll('[data-hc-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-hc-copy');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-guide-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hc-gbar]');
    if (!root) return;

    var KEY = 'hc-guide-result';
    var HIDE = 'hc-guide-bar-hidden';
    var row = root.querySelector('[data-hc-gbar-row]');
    var here = root.getAttribute('data-handle');

    function get(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }

    var stored = get(KEY);
    if (!stored) return;

    var data;
    try { data = JSON.parse(stored); } catch (e) { return; }
    if (!data || !data.items || !data.items.length) return;

    /* Zavření se pamatuje zvlášť od výsledku — zavřít lištu neznamená
       zahodit doporučení. Porovnává se čas: po novém průvodci je výsledek
       novější než zavření, takže se lišta zase ukáže. */
    var hiddenAt = Number(get(HIDE) || 0);
    if (hiddenAt && hiddenAt >= (data.ts || 0)) return;

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    data.items.forEach(function (it) {
      var current = it.handle && it.handle === here;
      var card = el('a', 'hc-gbar__card' + (current ? ' hc-gbar__card--current' : ''));
      card.href = it.url || '#';

      if (it.image) {
        var img = el('img', 'hc-gbar__thumb');
        img.src = it.image;
        img.alt = '';
        img.width = 72;
        img.height = 44;
        img.loading = 'lazy';
        card.appendChild(img);
      }

      var text = el('span', 'hc-gbar__text');
      if (current) text.appendChild(el('span', 'hc-gbar__now', root.getAttribute('data-now')));
      text.appendChild(el('span', 'hc-gbar__name', it.title || ''));
      if (it.role) text.appendChild(el('span', 'hc-gbar__role', it.role));
      card.appendChild(text);

      card.appendChild(el('span', 'hc-gbar__price', it.price || ''));
      row.appendChild(card);
    });

    root.hidden = false;

    /* Listování v dráze karet. Vidět jsou tři; když jich výsledek nese víc,
       ukážou se šipky a posouvají po jedné kartě. Krok se měří z karty,
       ne z konstanty — mobilní vrstva jí dává jinou šířku. */
    var nav = root.querySelector('[data-hc-gbar-nav]');
    var prev = root.querySelector('[data-hc-gbar-prev]');
    var next = root.querySelector('[data-hc-gbar-next]');
    if (nav && prev && next) {
      var krok = function () {
        var karta = row.firstElementChild;
        if (!karta) return row.clientWidth;
        var mezera = parseFloat(getComputedStyle(row).columnGap) || 0;
        return karta.getBoundingClientRect().width + mezera;
      };

      var stav = function () {
        /* scrollWidth bývá o zlomek px větší i bez přetečení, proto rezerva. */
        var lze = row.scrollWidth - row.clientWidth > 4;
        nav.hidden = !lze;
        if (!lze) return;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
      };

      prev.addEventListener('click', function () { row.scrollBy({ left: -krok() }); });
      next.addEventListener('click', function () { row.scrollBy({ left: krok() }); });
      row.addEventListener('scroll', stav);
      window.addEventListener('resize', stav);
      stav();
    }

    /* Sbalená lišta na mobilu: „3 nože". Čeština má tři tvary (1 / 2–4 /
       5 a víc), nastavení je nese oddělené svislítkem. */
    var toggle = root.querySelector('[data-hc-gbar-toggle]');
    var count = root.querySelector('[data-hc-gbar-count]');
    if (toggle && count) {
      var forms = (toggle.getAttribute('data-forms') || '').split('|');
      var n = data.items.length;
      var form = forms[n === 1 ? 0 : (n < 5 ? 1 : 2)] || forms[0] || '';
      count.textContent = n + ' ' + form;
      toggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var close = root.querySelector('[data-hc-gbar-close]');
    if (close) close.addEventListener('click', function () {
      root.hidden = true;
      try { localStorage.setItem(HIDE, String(Date.now())); } catch (e) {}
    });

    /* „Začít znovu" zahodí uložený výsledek, ať průvodce začíná od nuly. */
    var restart = root.querySelector('[data-hc-gbar-restart]');
    if (restart) restart.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); localStorage.removeItem(HIDE); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hc-guide]');
    if (!root) return;

    var dataEl   = root.querySelector('[data-hc-strom]');
    var screens  = root.querySelector('[data-hc-guide-screens]');
    var vysledek = root.querySelector('.hc-guide__result');
    var stepNo   = root.querySelector('[data-hc-guide-stepno]');
    var noteEl   = root.querySelector('[data-hc-guide-note]');
    var fill     = root.querySelector('[data-hc-guide-fill]');
    var back     = root.querySelector('[data-hc-guide-back]');
    var next     = root.querySelector('[data-hc-guide-next]');
    var restart  = root.querySelector('[data-hc-guide-restart]');
    var karty    = [].slice.call(root.querySelectorAll('[data-hc-guide-card]'));
    var poolUrl  = root.getAttribute('data-pool-url') || '/collections/all';
    var KROK     = root.getAttribute('data-step-label') || 'Krok';
    var RESULT_HANDLE = root.getAttribute('data-result-handle') || '';

    var model;
    try { model = JSON.parse(dataEl.textContent); } catch (e) { return; }

    /* Strom je ve skutečnosti graf: uzel typu ref se vrací na dřívější
       otázku. V modelu je ten odkaz jen textem, proto se cíl hledá podle
       názvu v uvozovkách. */
    function otazkaPodleNazvu(nazev) {
      var nalez = null;
      (function hledej(n) {
        if (nalez) return;
        if (n.t === 'q' && n.l === nazev) { nalez = n; return; }
        (n.c || []).forEach(hledej);
      })(model);
      return nalez;
    }
    function cilRefu(uzel) {
      var m = (uzel.l || '').match(/[„"]([^"“”]+)[“”"]/);
      return m ? otazkaPodleNazvu(m[1]) : null;
    }

    /* Kolik otázek ještě může přijít — z toho se počítá ukazatel. Strom má
       proměnnou hloubku (jedna až dvě otázky), takže pevné "ze čtyř" jako
       u starého průvodce nedává smysl. Pojistka proti zacyklení přes ref. */
    function hloubka(n, stop) {
      if (!n || (stop || 0) > 6) return 0;
      var d = n.t === 'q' ? 1 : 0;
      var nejvic = 0;
      (n.c || []).forEach(function (k) {
        var cil = k.t === 'ref' ? cilRefu(k) : k;
        nejvic = Math.max(nejvic, hloubka(cil, (stop || 0) + 1));
      });
      return d + nejvic;
    }

    var historie = [];
    var opener = null;

    /* Vede uzel někam, kde něco je? Uzly s off:1 jsou dlaždice, ke kterým
       v obchodě nejsou produkty (CLAUDE.md §19) — a odpověď, pod kterou
       zbyly jen takové, je slepá ulička. Bez téhle kontroly se „Hledám
       dárkovou sadu" otevřela jako prázdná obrazovka. */
    function pouzitelny(uzel, stop) {
      if (!uzel || uzel.off || (stop || 0) > 6) return false;
      if (uzel.t === 'l') return !!uzel.tag;
      if (uzel.t === 'r') return true;
      if (uzel.t === 'ref') return !!cilRefu(uzel);
      return (uzel.c || []).some(function (k) { return pouzitelny(k, (stop || 0) + 1); });
    }

    function dlazdice(uzel) {
      return (uzel.c || []).filter(function (k) { return pouzitelny(k); });
    }

    function otevri(uzel) {
      if (uzel.t === 'ref') {
        var cil = cilRefu(uzel);
        if (cil) zobraz(cil);
        return;
      }
      if (uzel.t === 'a') {
        var deti = dlazdice(uzel);
        if (deti.length === 1) { otevri(deti[0]); return; }
        zobraz(uzel);
        return;
      }
      if (uzel.t === 'q') { zobraz(uzel); return; }
      if (uzel.t === 'l') { naVypis(uzel); return; }
      if (uzel.t === 'r') { ukazVysledek(uzel); return; }
    }

    /* Konec typu vypis: uložit nože pro lištu nad produktovkou a odejít na
       filtrovanou kolekci. Filtruje se štítkem, takže adresa je prostě
       kolekce lomeno štítek — viz CLAUDE.md §19. */
    function naVypis(uzel) {
      if (!uzel.tag) { window.location.href = poolUrl; return; }
      uloz(karty.filter(function (el) {
        return (el.getAttribute('data-tags') || '').split('|').indexOf(uzel.tag) !== -1;
      }), uzel.l);
      window.location.href = poolUrl.replace(/\/$/, '') + '/' + uzel.tag;
    }

    /* Konec typu vysledek: jeden konkrétní nůž. V modelu je jen jménem,
       proto se hledá mezi vysázenými kartami podle názvu. Když se nenajde
       (jiný sortiment), spadne to na santoku, ať uživatel neskončí na
       prázdnu. */
    function ukazVysledek(uzel) {
      /* Nůž se bere z nastavení sekce (handle), ne z názvu uzlu: santoku
         165 je v obchodě osm a „Santoku 165 mm" z modelu by trefilo
         libovolné. Když handle není vyplněný nebo produkt v poolu není,
         ukáže se aspoň nabídka santoku. */
      var sedi = [];
      if (RESULT_HANDLE) {
        sedi = karty.filter(function (el) {
          return el.getAttribute('data-handle') === RESULT_HANDLE;
        });
      }
      /* Nabídka santoku bere délku z názvu uzlu („Santoku 165 mm" →
         delka-165). Bez toho se mezi tři karty dostal i malý santoku
         125 mm (ověřeno na živém webu 29. 9. 2026). Kdyby délka nic
         netrefila, zůstává nabídka všech santoku. */
      if (!sedi.length) {
        var santoku = karty.filter(function (el) {
          return (el.getAttribute('data-tags') || '').split('|').indexOf('tvar-santoku') !== -1;
        });
        var mm = /(\d+)\s*mm/.exec(uzel.l || '');
        sedi = mm ? santoku.filter(function (el) {
          return (el.getAttribute('data-tags') || '').split('|').indexOf('delka-' + mm[1]) !== -1;
        }) : [];
        if (!sedi.length) sedi = santoku;
      }
      if (!sedi.length) { window.location.href = poolUrl; return; }

      karty.forEach(function (el) { el.hidden = true; });
      sedi.slice(0, 3).forEach(function (el) { el.hidden = false; });
      uloz(sedi, uzel.l);

      screens.hidden = true;
      vysledek.hidden = false;
      var t = vysledek.querySelector('[data-hc-guide-title]');
      if (t) t.textContent = uzel.l;
      if (stepNo) stepNo.textContent = '';
      if (noteEl) noteEl.textContent = uzel.n || '';
      if (fill) fill.style.width = '100%';
      if (next) next.hidden = true;
      if (back) back.hidden = historie.length === 0;
      if (restart) restart.hidden = false;
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    /* Pro lištu nad produktovkou. Ukládá se víc než tři: lišta jich tři
       ukazuje a šipkami listuje dál. */
    function uloz(prvky, popis) {
      try {
        localStorage.setItem('hc-guide-result', JSON.stringify({
          ts: Date.now(),
          label: popis || '',
          items: prvky.slice(0, 12).map(function (e) {
            return {
              handle: e.getAttribute('data-handle'),
              url: e.getAttribute('data-url'),
              title: e.getAttribute('data-title'),
              role: e.getAttribute('data-role'),
              price: e.getAttribute('data-price'),
              image: e.getAttribute('data-image')
            };
          })
        }));
      } catch (err) {}
    }

    function zobraz(uzel) {
      var deti = dlazdice(uzel);
      screens.innerHTML = '';
      vysledek.hidden = true;

      var sekce = document.createElement('section');
      sekce.className = 'hc-guide__step';

      var h = document.createElement('h2');
      h.className = 'hc-guide__q';
      h.textContent = uzel.l || '';
      sekce.appendChild(h);

      var mrizka = document.createElement('div');
      mrizka.className = 'hc-guide__opts hc-guide__opts--' + Math.min(deti.length, 4);

      deti.forEach(function (dite) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hc-gopt hc-gopt--btn';
        var mark = document.createElement('span');
        mark.className = 'hc-gopt__mark';
        mark.setAttribute('aria-hidden', 'true');
        var text = document.createElement('span');
        text.className = 'hc-gopt__text';
        var lab = document.createElement('span');
        lab.className = 'hc-gopt__label';
        lab.textContent = dite.l || '';
        text.appendChild(lab);
        if (dite.s) {
          var pozn = document.createElement('span');
          pozn.className = 'hc-gopt__note';
          pozn.textContent = dite.s;
          text.appendChild(pozn);
        }
        b.appendChild(mark);
        b.appendChild(text);
        b.addEventListener('click', function () {
          historie.push(uzel);
          otevri(dite);
        });
        mrizka.appendChild(b);
      });

      sekce.appendChild(mrizka);
      screens.appendChild(sekce);
      screens.hidden = false;

      var hotovo = historie.filter(function (n) { return n.t === 'q'; }).length;
      var zbyva = Math.max(1, hloubka(uzel));
      if (stepNo) stepNo.textContent = KROK + ' ' + (hotovo + 1) + ' ze ' + (hotovo + zbyva);
      if (noteEl) noteEl.textContent = uzel.s || '';
      if (fill) fill.style.width = Math.round((hotovo + 1) / (hotovo + zbyva) * 100) + '%';
      if (next) next.hidden = true;
      if (back) back.hidden = historie.length === 0;
      if (restart) restart.hidden = historie.length === 0;
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    if (back) back.addEventListener('click', function () {
      var kam = historie.pop();
      zobraz(kam || model);
    });
    if (restart) restart.addEventListener('click', function () {
      historie = [];
      try { localStorage.removeItem('hc-guide-result'); } catch (err) {}
      zobraz(model);
    });

    zobraz(model);

    /* Otevírání pásu odkazem s href končícím na #hc-guide — stejná úmluva
       jako u modalu s deseti důvody. */
    function open(ev) {
      if (ev) { ev.preventDefault(); opener = ev.currentTarget; }
      root.hidden = false;
      document.addEventListener('keydown', onKey);
      root.focus();
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    function close() {
      root.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (opener && opener.focus) opener.focus();
    }
    function onKey(ev) { if (ev.key === 'Escape') close(); }

    document.querySelectorAll('a[href$="#hc-guide"]').forEach(function (a) {
      a.addEventListener('click', open);
    });
    root.querySelectorAll('[data-hc-guide-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    if (window.location.hash === '#hc-guide') open();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-hp-bestsellers"] && !Shopify.designMode) return;
  try {
    
  // Šipky jen posunou dráhu o jednu kartu; zacvaknutí dělá scroll-snap.
  document.querySelectorAll('[data-hc-best-track]').forEach(function (track) {
    var root = track.closest('.hc-best');
    if (!root) return;
    var prev = root.querySelector('[data-hc-best-prev]');
    var next = root.querySelector('[data-hc-best-next]');
    if (!prev && !next) return;

    function krok() {
      var karta = track.firstElementChild;
      if (!karta) return track.clientWidth;
      var mezera = parseFloat(getComputedStyle(track).columnGap) || 0;
      return karta.getBoundingClientRect().width + mezera;
    }

    // Bez `behavior` se použije scroll-behavior z CSS — a ten se v
    // 50-best.css vypíná při prefers-reduced-motion, takže se animace
    // řídí nastavením systému, ne natvrdo odsud.
    function jed(smer) {
      track.scrollBy({ left: smer * krok() });
    }

    if (prev) prev.addEventListener('click', function () { jed(-1); });
    if (next) next.addEventListener('click', function () { jed(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-pdp-ambassadors"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hc-pdp-amb').forEach(function (root) {
    var rail = root.querySelector('[data-hc-amb-rail]');
    var prev = root.querySelector('[data-hc-amb-prev]');
    var next = root.querySelector('[data-hc-amb-next]');
    var thumb = root.querySelector('[data-hc-amb-thumb]');
    if (!rail) return;

    /* Posun v pixelech, ne pořadové číslo karty. Tažení myší řadu
       zastaví kdekoliv, takže index by stejně přestal být pravdivý;
       šipky si krok dopočítají z posunu. */
    var shift = 0;

    /* Krok = skutečná šířka karty + skutečná mezera railu, ne natvrdo
       415 px. Na desktopu to 415 vyjde (383 + 32), ale mobilní vrstva
       kartu sráží na 267 a mezeru na 8 — s konstantou tam šipka
       přeskakovala rovnou půldruhé karty. */
    function step() {
      var card = rail.querySelector('.hc-pdp-amb__card');
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : 415;
    }

    /* Vidět je od levé hrany railu po pravý okraj railwrapu — pátá karta
       schválně vykukuje za kontejner (ořez dělá okno, ne kontejner),
       takže rail.clientWidth by vyšel menší, než co je opravdu vidět.

       Levá hrana se NEBERE z rail.getBoundingClientRect(): ten už nese
       translateX, takže by se posun započítal dvakrát. Počítá se proto
       z netransformovaného kontejneru a jeho vnitřního odsazení. */
    function measure() {
      var wrap = root.querySelector('.hc-pdp-amb__railwrap');
      var cont = rail.parentNode;
      var railLeft = cont.getBoundingClientRect().left
                   + (parseFloat(getComputedStyle(cont).paddingLeft) || 0);
      var visible = (wrap ? wrap.getBoundingClientRect().right
                          : cont.getBoundingClientRect().right) - railLeft;
      var total = rail.scrollWidth;
      /* Kolik je vůbec potřeba odrolovat. Posun se tím ořezává, jinak by
         řada přejela za konec a vpravo by zbylo prázdno. */
      return { total: total, visible: visible, max: Math.max(0, total - visible) };
    }

    /* Při tažení se míry nepřepočítávají na každý pohyb myši — jsou po
       celou dobu stejné a getBoundingClientRect se scrollWidth jsou
       vynucené přepočty rozvržení. */
    var frozen = null;

    function apply(animate) {
      var m = frozen || measure();
      if (shift > m.max) shift = m.max;
      if (shift < 0) shift = 0;

      rail.style.transition = animate ? '' : 'none';
      rail.style.transform = 'translateX(' + -shift + 'px)';
      if (prev) prev.disabled = shift <= 0.5;
      if (next) next.disabled = shift >= m.max - 0.5;

      if (thumb && m.total) {
        thumb.style.width = Math.min(100, m.visible / m.total * 100) + '%';
        thumb.style.left = Math.min(100, shift / m.total * 100) + '%';
      }
    }

    function posun(o) { shift += o; apply(true); }

    if (prev) prev.addEventListener('click', function () { posun(-step()); });
    if (next) next.addEventListener('click', function () { posun(step()); });

    /* ---- Tažení myší ----
       Rail není scroller (ořez dělá railwrap, aby pátá karta mohla
       vykukovat za kontejner), takže tažení posouvá rovnou translateX.
       Pojistky jsou stejné jako u sourozence .hc-amb v hobbychef.js:
         * jen levé tlačítko myši a jen pointerType 'mouse',
         * preventDefault na pointerdown, jinak prohlížeč začne táhnout
           fotku jako obrázek a vybírat text,
         * transition dočasně vypnutá, jinak se řada táhne se zpožděním
           0,35 s za kurzorem,
         * kliknutí po tažení se zahazuje v capture fázi, jinak by
           puštění myši nad kartou otevřelo odkaz pod ní (karta je <a>,
           když má ambasador vyplněný odkaz). */
    var dragging = false, startX = 0, startShift = 0, moved = 0;

    /* Prst a pero (24. 10. 2026, poznámka grafičky 5): rail není scroller,
       takže nativní posun prstem tu nikdy nebyl — šlo to jen šipkami.
       Svislý posun stránky dál dělá prohlížeč (touch-action: pan-y na
       railu), vodorovný tah posouvá řadu stejně jako myš. Když prohlížeč
       gesto převezme na svislý posun, pošle pointercancel → endDrag. */
    rail.addEventListener('pointerdown', function (e) {
      var mys = e.pointerType === 'mouse';
      if (mys && e.button !== 0) return;
      dragging = true; moved = 0;
      startX = e.clientX; startShift = shift;
      frozen = measure();
      try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      root.classList.add('is-dragging');
      if (mys) e.preventDefault();
    });

    rail.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      shift = startShift - dx;
      apply(false);
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      frozen = null;
      root.classList.remove('is-dragging');
      try { rail.releasePointerCapture(e.pointerId); } catch (err) {}
      apply(true);
    }
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);

    /* Vodorovné gesto touchpadu (a Shift + kolečko). Svislé kolečko
       nechává stránce; na kraji řady se gesto pustí dál, aby šlo
       v prohlížeči listovat zpět. */
    rail.addEventListener('wheel', function (e) {
      var dx = e.deltaX || (e.shiftKey ? e.deltaY : 0);
      if (!dx || Math.abs(dx) < Math.abs(e.shiftKey ? 0 : e.deltaY)) return;
      var m = measure();
      if ((dx < 0 && shift <= 0) || (dx > 0 && shift >= m.max)) return;
      if (e.deltaMode === 1) dx *= 16;
      shift += dx;
      apply(false);
      e.preventDefault();
    }, { passive: false });

    /* 5 px je práh, pod kterým je to ještě kliknutí, ne tažení. */
    rail.addEventListener('click', function (e) {
      if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }, true);

    window.addEventListener('resize', function () { apply(false); });
    window.addEventListener('load', function () { apply(false); });

    apply(false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  /* „Zobrazit všechny recenze“ odkryje karty schované stavovou třídou
     hc-pdp-reviews--collapsed. Posluchač je jeden, delegovaný na dokument,
     takže přežije i překreslení sekce v editoru themu. Tlačítko po
     rozbalení zmizí, fokus proto jde na první nově odkrytou kartu — která
     to je, záleží na šířce okna, tak se bere podle skutečného display. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hc-reviews-all]');
    if (!btn) return;
    var root = btn.closest('.hc-pdp-reviews');
    if (!root) return;
    var skryte = [].filter.call(root.querySelectorAll('.hc-pdp-reviews__card'), function (c) {
      return getComputedStyle(c).display === 'none';
    });
    root.classList.remove('hc-pdp-reviews--collapsed');
    btn.setAttribute('aria-expanded', 'true');
    if (skryte.length) {
      skryte[0].setAttribute('tabindex', '-1');
      skryte[0].focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-product-grid"] && !Shopify.designMode) return;
  try {
    
  /* Šipky pod vodorovnou dráhou karet. Roluje se o šířku karty i s mezerou,
     takže se dráha vždycky zastaví na začátku další karty. Na desktopu jsou
     šipky schované a mřížka neroluje, takže se nic nestane. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-hc-pgrid]') : null;
    if (!btn) return;
    var band = btn.closest('.hc-pgrid__band');
    var rail = band && band.querySelector('.hc-pgrid__grid');
    if (!rail) return;
    var karta = rail.firstElementChild;
    var krok = karta ? karta.getBoundingClientRect().width + 8 : rail.clientWidth;
    rail.scrollBy({ left: krok * Number(btn.getAttribute('data-hc-pgrid')), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-product-main"] && !Shopify.designMode) return;
  try {
    
  // Počet kusů, galerie (náhledy a přejetí prstem) a přepínač variant.
  // Bez závislostí.
  document.querySelectorAll('.hc-pm').forEach(function (root) {
    var input = root.querySelector('.hc-pm__qty-input');
    root.querySelectorAll('.hc-pm__qty-btn').forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, i === 0 ? v - 1 : v + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // ── Galerie ─────────────────────────────────────────────────────
    // Náhled vymění fotku ve scéně; na dotykovém displeji jde fotka
    // posunout i prstem, v pořadí náhledů. Aktivní náhled nese
    // aria-current — mobilní vrstva ho podle toho orámuje
    // (f2-pdp-nakup.css), desktop vzhledově nic nemění.
    var stage = root.querySelector('.hc-pm__stage-img');
    var box = root.querySelector('.hc-pm__stage');
    var thumbs = [].slice.call(root.querySelectorAll('.hc-pm__thumb'));
    // Jedna fotka nebo žádná: není mezi čím přepínat, takže se nic ani
    // neoznačuje — orámovaný jediný náhled by jen změnil vzhled stránky.
    var gal = !!(stage && box && thumbs.length > 1);
    var cur = -1;   // index náhledu, jehož fotka je ve scéně; −1 = žádného

    // Náhled je vysázený na 336 px, scéna má 848 CSS px (zdroj 1696 px).
    // Bez data-full by se do scény vložila 336px miniatura a fotka by
    // po přepnutí byla rozmazaná.
    function full(i) {
      var img = thumbs[i].querySelector('img');
      return img ? img.getAttribute('data-full') || img.src : '';
    }

    function mark(i) {
      cur = i;
      if (!gal) return;
      thumbs.forEach(function (t, j) {
        if (j === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    // Přepne JEN fotku. Variantu přepíná posluchač u náhledů
    // s data-hc-variant níž, a to jen na klik — přejetím prstem se měnit
    // nesmí, zákazník by si nevědomky změnil průměr pánve v košíku.
    function show(i) {
      var img = thumbs[i] && thumbs[i].querySelector('img');
      if (!stage || !img) return;
      stage.src = full(i);
      stage.alt = img.alt;
      mark(i);
    }

    // Který náhled patří fotce ve scéně. Scéna nemusí začínat první fotkou
    // (u varianty se sází ta její) a apply() níž ji mění zvenku. Porovnává
    // se adresa bez dotazu, ať nevadí jiné ?width=.
    function sync() {
      if (!gal) return;
      var src = (stage.getAttribute('src') || '').split('?')[0];
      var hit = -1;
      thumbs.forEach(function (t, j) {
        if (hit < 0 && full(j).split('?')[0] === src) hit = j;
      });
      mark(hit);
    }

    // Přejetí prstem. Pointer Events jen pro dotyk a pero — myš na
    // desktopu nedělá nic nového. Svislý tah si díky touch-action: pan-y
    // bere prohlížeč (roluje stránku a pošle pointercancel), vodorovný
    // jde sem. Fotka jede za prstem a z boku přijíždí sousední
    // (.hc-pm__stage-ghost); na krajích se nepřetáčí dokola, jen pruží.
    function swipe() {
      var PRAH = 40;      // px tahu, od kolika se po puštění přepne
      var DUR = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 250;
      var sousede = {};   // index → <img> sousední fotky
      var ghost = null;   // soused, který je právě vidět
      var tah = null;     // rozpracovaný tah
      var busy = false;   // dojíždí animace, další tah počká

      // Sousední fotka. Vzniká napřed — při dotyku a po každé výměně — a
      // velká verze se hned stahuje, takže výměna nečeká na síť. Do jejího
      // stažení ukazuje soused miniaturu z náhledu, která už stažená je:
      // na pomalé síti (3G) jinak první tah přivezl 0,6 s bílé plochy.
      // Každý soused má vlastní <img>, protože img drží starou fotku, dokud
      // se nová nestáhne — se společným by z boku přijížděla ta předchozí.
      function soused(i) {
        if (i < 0 || i >= thumbs.length) return null;
        if (!sousede[i]) {
          var g = document.createElement('img');
          var mini = thumbs[i].querySelector('img');
          var velka = new Image();
          g.className = 'hc-pm__stage-ghost';
          g.alt = '';
          g.setAttribute('aria-hidden', 'true');
          g.hidden = true;
          g.src = mini ? mini.src : full(i);
          velka.onload = function () { g.src = velka.src; };
          velka.src = full(i);
          box.appendChild(g);
          sousede[i] = g;
        }
        return sousede[i];
      }

      function ukaz(g) {
        if (ghost === g) return;
        if (ghost) {
          ghost.hidden = true;
          ghost.style.transition = ghost.style.transform = '';
        }
        ghost = g;
        if (ghost) ghost.hidden = false;
      }

      // x = posun hlavní fotky, g = posun sousední, obojí v px sekce.
      function posun(x, g, anim) {
        var tr = anim ? 'transform ' + DUR + 'ms ease-out' : 'none';
        stage.style.transition = tr;
        stage.style.transform = 'translateX(' + x + 'px)';
        if (ghost) {
          ghost.style.transition = tr;
          ghost.style.transform = 'translateX(' + g + 'px)';
        }
      }

      function hotovo() {
        stage.style.transition = stage.style.transform = '';
        ukaz(null);
        busy = false;
        soused(cur - 1);
        soused(cur + 1);
      }

      box.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
        if (tah || busy) return;
        soused(cur - 1);
        soused(cur + 1);
        var w = box.offsetWidth;
        tah = {
          id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, dy: 0, w: w,
          // Pod 1100 px je sekce zmenšená přes zoom (hobbychef-pdp.css).
          // Prst jede v px okna, translateX v px sekce: offsetWidth je bez
          // zoomu, getBoundingClientRect se zoomem. Bez přepočtu by fotka
          // na tabletu za prstem zaostávala (na 900 px o 18 %).
          k: w / (box.getBoundingClientRect().width || w),
          jede: false,   // vodorovný tah potvrzený
          kam: -1        // index přijíždějící fotky; −1 = kraj
        };
      });

      box.addEventListener('pointermove', function (e) {
        if (!tah || e.pointerId !== tah.id) return;
        tah.dx = e.clientX - tah.x;
        tah.dy = e.clientY - tah.y;
        if (!tah.jede) {
          // Směr se rozhodne až po pár px, chvění prstu nic nespouští.
          if (Math.abs(tah.dx) < 8 && Math.abs(tah.dy) < 8) return;
          if (Math.abs(tah.dx) <= Math.abs(tah.dy)) { tah = null; return; }
          tah.jede = true;
        }
        var x = tah.dx * tah.k;
        var kam = cur + (x < 0 ? 1 : -1);
        var g = soused(kam);
        if (!g) {
          // Za krajní fotkou nic není: jen pruží, třetinou tahu.
          tah.kam = -1;
          ukaz(null);
          posun(x / 3, 0, false);
          return;
        }
        tah.kam = kam;
        ukaz(g);
        posun(x, x < 0 ? x + tah.w : x - tah.w, false);
      });

      function pustit(e) {
        if (!tah || e.pointerId !== tah.id) return;
        var t = tah;
        tah = null;
        if (!t.jede) return;
        busy = true;
        var smer = t.dx < 0 ? -1 : 1;
        var dal = e.type === 'pointerup' && t.kam >= 0 &&
          Math.abs(t.dx) >= PRAH && Math.abs(t.dx) > Math.abs(t.dy);
        if (!dal) {
          // Zpátky na místo, soused odjede, odkud přijel.
          posun(0, -smer * t.w, true);
          setTimeout(hotovo, DUR);
          return;
        }
        // Hlavní fotka odjede, soused dojede na její místo. Pak jde do scény
        // nejdřív přesně to, co soused ukazuje (je stažené), a soused zmizí
        // až po decode() — jinak by na okamžik blikla prázdná plocha. Velká
        // fotka jde do scény až potom (show): img drží předchozí obrázek,
        // dokud se nový nestáhne, takže se na síť nečeká a dá se táhnout dál.
        // Čekat rovnou na velkou nejde — studená CDN ji vydávala i 3 s.
        posun(smer * t.w, 0, true);
        setTimeout(function () {
          stage.src = ghost.src;
          var dokonci = function () { show(t.kam); hotovo(); };
          var p = stage.decode ? stage.decode() : null;
          if (p) p.then(dokonci, dokonci);
          else dokonci();
        }, DUR + 20);
      }
      box.addEventListener('pointerup', pustit);
      box.addEventListener('pointercancel', pustit);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
    sync();
    if (gal) swipe();

    // ── Přepínač variant ────────────────────────────────────────────
    // Volby jsou odkazy `?variant=<id>`, takže bez JS (a při chybě tady)
    // variantu přepne Shopify samo načtením stránky. Tenhle skript to jen
    // udělá na místě, ať nezmizí rozepsané gravírování a počet kusů.
    var vbox = root.querySelector('.hc-pm__opts');
    var vdata = vbox && vbox.querySelector('script[data-hc-variants]');
    var list = [];
    if (vdata) {
      try { list = JSON.parse(vdata.textContent) || []; } catch (e) { list = []; }
    }
    if (!vbox || !list.length) return;

    var labIn = vbox.getAttribute('data-hc-in') || '';
    var labOut = vbox.getAttribute('data-hc-out') || '';
    // Zaškrtnutá varianta nebo štítek Nedostupné ("n" v JSON, §39) má vlastní
    // text — „Momentálně nedostupné“ není totéž co vyprodáno.
    var labNed = vbox.getAttribute('data-hc-ned') || labOut;
    function labNe(v) { return v.n ? labNed : labOut; }
    var labNone = vbox.getAttribute('data-hc-none') || '';

    var byId = {};
    list.forEach(function (v) { byId[String(v.id)] = v; });

    var groups = [].slice.call(vbox.querySelectorAll('.hc-pm__opt-vals')).map(function (g) {
      var name = g.parentNode.querySelector('.hc-pm__opt-name');
      return {
        el: g,
        name: name ? name.textContent : '',
        chips: [].slice.call(g.querySelectorAll('.hc-pm__opt-chip'))
      };
    });
    if (!groups.length) return;

    var first = groups[0].chips[0];
    var purl = first ? first.getAttribute('href').split('?')[0] : window.location.pathname;

    var form = root.querySelector('.hc-pm__form form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function same(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) { if (a[i] !== b[i]) return false; }
      return true;
    }

    function samePrefix(ov, pref) {
      if (!ov || ov.length < pref.length) return false;
      for (var i = 0; i < pref.length; i++) { if (ov[i] !== pref[i]) return false; }
      return true;
    }

    // Stejné tři kola jako v Liquidu: celá kombinace, pak kaskáda
    // (hodnoty options před touhle), nakonec kterákoli varianta s tou
    // hodnotou. Přednost má varianta skladem.
    function target(gi, val, cur) {
      var full = cur.slice();
      full[gi] = val;
      var pref = cur.slice(0, gi);
      pref.push(val);
      var exact = null, pre = null, preOk = null, any = null, anyOk = null;
      list.forEach(function (v) {
        if (!v.ov || v.ov[gi] !== val) return;
        if (!exact && same(v.ov, full)) exact = v;
        if (samePrefix(v.ov, pref)) {
          if (!pre) pre = v;
          if (!preOk && v.a) preOk = v;
        }
        if (!any) any = v;
        if (!anyOk && v.a) anyOk = v;
      });
      if (exact) return { v: exact, fit: true };
      if (pre) return { v: preOk || pre, fit: true };
      if (any) return { v: anyOk || any, fit: false };
      return null;
    }

    function paint(cur) {
      groups.forEach(function (g, gi) {
        g.chips.forEach(function (chip) {
          var val = chip.getAttribute('data-hc-val');
          chip.classList.remove('is-sel', 'is-out', 'is-none');
          chip.removeAttribute('aria-current');
          chip.removeAttribute('title');
          var r = target(gi, val, cur);
          if (!r) return;
          chip.setAttribute('data-hc-variant', String(r.v.id));
          chip.setAttribute('href', purl + '?variant=' + r.v.id);
          if (val === cur[gi]) {
            chip.classList.add('is-sel');
            chip.setAttribute('aria-current', 'true');
          } else if (!r.fit) {
            chip.classList.add('is-none');
            chip.setAttribute('title', g.name + ' ' + val + ' — ' + labNone);
          } else if (!r.v.a) {
            chip.classList.add('is-out');
            chip.setAttribute('title', g.name + ' ' + val + ' — ' + labNe(r.v));
          }
        });
      });
    }

    function apply(id) {
      var v = byId[String(id)];
      if (!v) return false;

      if (idInput) idInput.value = String(v.id);

      var price = root.querySelector('.hc-pm__price');
      var now = price ? price.querySelector('.hc-pm__price-now') : null;
      if (now) now.textContent = v.p;
      var old = price ? price.querySelector('.hc-pm__price-old') : null;
      if (v.o) {
        // Prázdný <s> se nesází nikdy — držel by sloupec 117 px a velká
        // cena by u varianty bez škrtnuté ceny začínala vpravo (viz
        // komentář u .hc-pm__price-old).
        if (!old && price && now) {
          old = document.createElement('s');
          old.className = 'hc-pm__price-old';
          price.insertBefore(old, now);
        }
        if (old) old.textContent = v.o;
      } else if (old && old.parentNode) {
        old.parentNode.removeChild(old);
      }

      var sku = root.querySelector('[data-hc-sku]');
      if (sku) sku.textContent = v.sku || '';

      var stxt = root.querySelector('.hc-pm__stock-item--avail .hc-pm__stock-txt');
      if (stxt) stxt.textContent = v.a ? labIn : labNe(v);
      var dot = root.querySelector('.hc-pm__dot');
      if (dot) dot.classList.toggle('hc-pm__dot--out', !v.a);
      var deliv = root.querySelector('.hc-pm__stock-item--deliv');
      if (deliv) {
        if (v.a) deliv.removeAttribute('hidden');
        else deliv.setAttribute('hidden', '');
      }

      var cta = root.querySelector('.hc-pm__cta');
      if (cta) cta.disabled = !v.a;
      var barCta = root.querySelector('.hc-pm__bar-cta');
      if (barCta) barCta.disabled = !v.a;
      var barPrice = root.querySelector('.hc-pm__bar-price');
      if (barPrice) barPrice.textContent = v.p;
      var barStock = root.querySelector('.hc-pm__bar-stock');
      if (barStock) {
        barStock.textContent = v.a ? labIn : labNe(v);
        barStock.classList.toggle('is-out', !v.a);
      }

      if (v.img) {
        if (stage) { stage.src = v.img; stage.alt = v.t || stage.alt; }
        sync();   // aktivní náhled za fotkou varianty
        var barThumb = root.querySelector('.hc-pm__bar-thumb');
        if (barThumb) barThumb.src = v.img;
      }

      // Poklička zdarma podle průměru varianty (snippets/hc-poklicka.liquid).
      // "pk" je v JSON jen u nádobí; null = k té variantě se nenabízí, řádek
      // se schová a zaškrtávátko vypne (vypnuté do košíku nejde).
      var pkRow = root.querySelector('[data-hc-poklicka]');
      if (pkRow && 'pk' in v) {
        var pkIn = pkRow.querySelector('input');
        var pkName = pkRow.querySelector('[data-hc-poklicka-nazev]');
        var pkCena = pkRow.querySelector('[data-hc-poklicka-cena]');
        if (v.pk) {
          pkRow.removeAttribute('hidden');
          if (pkIn) { pkIn.disabled = false; pkIn.setAttribute('data-hc-item', String(v.pk[0])); }
          if (pkName) pkName.textContent = v.pk[1];
          if (pkCena) pkCena.textContent = v.pk[2];
        } else {
          pkRow.setAttribute('hidden', '');
          if (pkIn) pkIn.disabled = true;
        }
      }

      paint(v.ov || []);

      // replaceState, ne pushState: tlačítkem Zpět se má vrátit předchozí
      // stránka, ne předchozí velikost. Adresa přesto nese variantu, takže
      // sdílený odkaz i obnovení stránky ukážou tu vybranou.
      // V try schválně: v dokumentu bez původu (náhled z file://, sandbox)
      // replaceState vyhodí SecurityError a bez pojistky by výjimka utekla
      // z apply() ještě před `return true` — volající by pak nezastavil
      // odkaz a stránka by se přesto přenačetla.
      try {
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', purl + '?variant=' + v.id);
        }
      } catch (e) { /* adresa zůstane stará, přepnuto je */ }
      return true;
    }

    vbox.addEventListener('click', function (ev) {
      var chip = ev.target && ev.target.closest ? ev.target.closest('.hc-pm__opt-chip') : null;
      if (!chip) return;
      // Ctrl/Cmd/prostředním tlačítkem si má odkaz otevřít novou kartu.
      if (ev.button || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      if (apply(chip.getAttribute('data-hc-variant'))) ev.preventDefault();
    });

    // Náhled patřící variantě přepne i variantu, ne jen fotku.
    root.querySelectorAll('.hc-pm__thumb[data-hc-variant]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        apply(thumb.getAttribute('data-hc-variant'));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-reviews"] && !Shopify.designMode) return;
  try {
    
  // Šipky jen posunou dráhu o jednu kartu; zacvaknutí dělá scroll-snap.
  // Stejný princip jako u bestsellerů (sections/hc-hp-bestsellers.liquid).
  document.querySelectorAll('[data-hc-rev-track]').forEach(function (track) {
    var root = track.closest('.hc-reviews');
    if (!root) return;
    var prev = root.querySelector('[data-hc-rev-prev]');
    var next = root.querySelector('[data-hc-rev-next]');
    if (!prev && !next) return;

    function krok() {
      var karta = track.firstElementChild;
      if (!karta) return track.clientWidth;
      var mezera = parseFloat(getComputedStyle(track).columnGap) || 0;
      return karta.getBoundingClientRect().width + mezera;
    }

    function jed(smer) {
      track.scrollBy({ left: smer * krok(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { jed(-1); });
    if (next) next.addEventListener('click', function () { jed(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  /* Řazení výpisu. Shopify u blogů neumí řadit přes URL (Liquid nevidí
     query parametry), takže přehazujeme pořadí karet na aktuální straně.
     Výchozí pořadí = pořadí z blogu, tedy „Nejnovější“. */
  document.querySelectorAll('[data-hc-bloglist-sort]').forEach(function (select) {
    var root = select.closest('.hc-bloglist');
    if (!root) return;
    var grid = root.querySelector('[data-hc-bloglist-grid]');
    if (!grid) return;

    var original = Array.prototype.slice.call(grid.children);

    select.addEventListener('change', function () {
      var cards = select.value === 'oldest' ? original.slice().reverse() : original;
      cards.forEach(function (card) { grid.appendChild(card); });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
